import {User} from '../../model/security/user';
// @ts-ignore
import {ApiValidation} from "../../model/api/api-validation";
import {FieldResult} from "../../model/api/field-result";
import {TableRecordResult} from "../../model/api/table-record-result";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {Notification} from "../../model/security/notification";
import {SyncMetadata} from "../../model/api/sync-metadata";
import {UserGroup} from "../../model/security/user-group";

export class CrystalclearSecurityBackUrl {
  static readonly GET_SECURITY_USER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<User>> = {
    url: '/api/security/user/list',
    type: TableRecordResult
  };
  static readonly GET_SECURITY_USER: CrystalclearBackUrl.UrlConf<ApiValidation<User>> = {
    url: '/api/security/user/get',
    type: ApiValidation
  };

  static readonly SAVE_SECURITY_USER: CrystalclearBackUrl.UrlConf<ApiValidation<User>> = {
    url: '/api/security/user/save',
    type: ApiValidation
  };

  static readonly SAVE_SECURITY_USER_BATCH: CrystalclearBackUrl.UrlConf<ApiValidation<User>> = {
    url: '/api/security/user/save-batch',
    type: ApiValidation
  };

  static readonly UPDATE_INFOS_SECURITY_USER: CrystalclearBackUrl.UrlConf<ApiValidation<User>> = {
    url: '/api/security/user/updateInfos',
    type: ApiValidation
  };

  static readonly DELETE_SECURITY_USER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/security/user/delete',
    type: ApiValidation
  };

  static readonly SECURITY_REFRESH_ACTIVITY: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/security/user/refresh-activity',
    type: ApiValidation
  };

  static readonly POST_NOTIFICATIONS_SYNC: CrystalclearBackUrl.UrlConf<ApiValidation<SyncMetadata>> = {
    url: '/api/security/notification/get-sync',
    type: ApiValidation
  }

  static readonly GET_NOTIFICATIONS_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Notification>> = {
    url: '/api/security/notification/list',
    type: TableRecordResult
  }

  static readonly GET_NOTIFICATIONS: CrystalclearBackUrl.UrlConf<ApiValidation<Notification[]>> = {
    url: '/api/security/notification/get',
    type: ApiValidation
  }

  static readonly SAVE_NOTIFICATION: CrystalclearBackUrl.UrlConf<ApiValidation<Notification>> = {
    url: '/api/security/notification/save',
    type: ApiValidation
  }

  static readonly DELETE_NOTIFICATION: CrystalclearBackUrl.UrlConf<ApiValidation<Notification>> = {
    url: '/api/security/notification/delete',
    type: ApiValidation
  }

  static readonly DELETE_ALL_NOTIFICATION: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/security/notification/delete-all',
    type: ApiValidation
  }

  static readonly GET_SECURITY_USER_GROUP_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<UserGroup>> = {
    url: '/api/security/user-group/list',
    type: TableRecordResult
  };

  static readonly SAVE_SECURITY_USER_GROUP: CrystalclearBackUrl.UrlConf<ApiValidation<UserGroup>> = {
    url: '/api/security/user-group/save',
    type: ApiValidation
  };

  static readonly DELETE_SECURITY_USER_GROUP: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/security/user-group/delete',
    type: ApiValidation
  };
}
